import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createDocument, getDocument, ICreateDocumentRequest } from "../services/document.service";
import { useUpdateDocumentText } from "./useUpdateDocumentText";

/**
 * Hook for creating a new document
 */
export const useCreateDocument = () => {
  const queryClient = useQueryClient();
  const updateDocumentTextMutation = useUpdateDocumentText();

  return useMutation({
    mutationFn: (data: ICreateDocumentRequest) => createDocument(data),
    onSuccess: async (data, variables) => {
      // Invalidate document queries to refetch with the newly created document
      queryClient.invalidateQueries({ queryKey: ["document"] });

      if (data.document_id) {
        try {
          const newDocument = await getDocument(data.document_id);
          if (newDocument.upload_text_url && variables.content) {
            updateDocumentTextMutation.mutate({
              url: newDocument.upload_text_url,
              text: variables.content,
            });
          }
        } catch (error) {
          console.error("Failed to fetch new document or upload text:", error);
        }
      }
    },
    onError: (error) => {
      console.error("Failed to create document:", error);
    },
  });
};
